import { createApiClient } from '../../api/client';
import { clearAuthStorage } from '../../utilities/authSession';

const authState = {
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  isLoggedIn: localStorage.getItem('isLoggedIn') === 'true',
};

function persistAuth(user) {
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('isLoggedIn', 'true');
}

const actions = {
  async login({ commit }, { username, password, apiLink }) {
    let client;

    try {
      client = createApiClient(apiLink);
      await client.post('/auth/login', { username, password });
    } catch (error) {
      return {
        success: false,
        reason: error && error.response && error.response.status === 401
          ? 'credentials'
          : 'login_request',
        status: error && error.response ? error.response.status : null,
      };
    }

    try {
      const meResponse = await client.get('/auth/me');
      const userData = meResponse.data.user || { username };

      commit('setUser', userData);
      commit('setLoginStatus', true);
      persistAuth(userData);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        reason: 'session',
        status: error && error.response ? error.response.status : null,
      };
    }
  },

  async logout({ commit }) {
    try {
      const client = createApiClient();
      await client.post('/auth/logout');
    } catch (error) {
      // Logout should still clear local auth state even if backend call fails.
    } finally {
      commit('clearAuth');
      clearAuthStorage();
    }
  },

  getCurrentUser({ state: currentState }) {
    return currentState.user;
  },

  async checkAuth({ commit }) {
    try {
      const client = createApiClient();
      const response = await client.get('/auth/me');
      const { user } = response.data;

      if (!user) {
        throw new Error('Missing user payload in auth/me response');
      }

      commit('setUser', user);
      commit('setLoginStatus', true);
      persistAuth(user);
      return true;
    } catch (error) {
      commit('clearAuth');
      clearAuthStorage();
      return false;
    }
  },
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setLoginStatus(state, status) {
    state.isLoggedIn = status;
  },
  clearAuth(state) {
    state.user = null;
    state.isLoggedIn = false;
  },
};

const getters = {
  isAuthenticated: currentState => currentState.isLoggedIn && !!currentState.user,
  getUser: currentState => currentState.user,
  getUsername: currentState => (currentState.user?.username || ''),
  getUserId: currentState => (currentState.user?.id || null),
};

export default {
  namespaced: true,
  state: authState,
  actions,
  mutations,
  getters,
};
